<template>
  <div v-show="isShow.isPTShow" class="pg2">
    <div class="p2-header">
      <div class="header-txt-wp" @click="showContent">
        <div class="header-notice">
          <div class="spot" v-show="list.length">
            <div class="spot-inner"></div>
          </div>
          <div class="header-notice-txt">
            <span>点这里查看</span>
            <span>已践行的事</span>
          </div>
        </div>
        <div class="header-txt">
          <div class="header-num">{{ list.length }}</div>
          <div class="header-complete">已完成</div>
        </div>
      </div>
      <div class="content-wrapper" v-if="isContent && list.length">
        <ul class="content-wp">
          <draggable :list="list" :disabled="true">
            <li class="content-item" v-for="(item, idx) in list" :key="item">
              <div class="content-item-txt">
                <span class="txt-num">
                  {{ idx > 8 ? idx + 1 : '0' + (idx + 1) }}.
                </span>
                <span class="txt-content">{{ item }}</span>
              </div>
              <div class="content-cross" @click="removeList(item)"></div>
            </li>
          </draggable>
        </ul>
        <div class="content-fold" @click="hideContent">
          <span>收起</span>
          <div class="conetnt-arrow">▲</div>
        </div>
      </div>
    </div>
    <div class="top-notice shineIt"></div>
    <div class="notice">
      <p class="transLeftRight">左右滑动可加速</p>
    </div>
    <div class="btn-bottom" v-show="list.length">
      <div class="btn1"></div>
      <div
        class="btn2"
        :class="isClicked ? '' : 'btn2__trans'"
        @click="showNext"
      ></div>
    </div>
  </div>
</template>

<script>
import * as PIXI from 'pixi.js'
import draggable from 'vuedraggable'
import { textData } from './textData'

const Application = PIXI.Application
const Container = PIXI.Container
const Sprite = PIXI.Sprite

export default {
  name: 'PageTwo',
  props: {
    isShow: Object,
  },
  data() {
    return {
      seletedNum: 0,
      outContainer: null,
      jsonFile: _const.host+ _const.path+'/common/logo-sprites.json',
      isClicked: false,
      textureId: null,
      list: [],
      isContent: false,
    }
  },
  components: {
    draggable,
  },
  watch: {
    'isShow.isPTShow': function () {
      this.init()
    },
  },
  methods: {
    showNext() {
      this.$emit('sdList', this.list)
      this.isClicked = true
      setTimeout(() => {
        this.$emit('nextPage', 'isPHShow')
      }, 300)
    },
    showContent() {
      if (this.isContent) {
        this.isContent = false
      } else {
        this.isContent = true
      }
    },
    hideContent() {
      // console.log('click')
      this.$nextTick(() => {
        this.isContent = false
      })
      this.isContent = false
    },
    init() {
      const w = window.innerWidth
      const h = window.innerHeight
      const app = new Application({
        width: w,
        height: h,
        antialias: true,
        resolution: 2,
        backgroundColor: 0xfefff9,
      })

      const container = document.querySelector('.pg2')
      container.appendChild(app.view)
      const outContainer = new Container()
      this.outContainer = outContainer
      outContainer.width = w
      outContainer.height = h
      outContainer.position.set(0, 0)

      outContainer.interactive = true
      let flag = true
      let originX

      const target = document.getElementsByTagName('canvas')[0]

      target.addEventListener('touchmove', (evt) => {
        const ordinateX = evt.touches[0].clientX
        const diff = ordinateX - originX
        outContainer.position.x += diff / 10
        app.renderer.render(outContainer)
      })

      target.addEventListener('touchstart', (evt) => {
        originX = evt.touches[0].clientX
      })

      target.addEventListener('touchend', () => {
        flag = true
      })

      app.stage.addChild(outContainer)
      const loader = new PIXI.Loader()
      const _this = this
      loader.add(this.jsonFile).load(setup)
      function setup(loader, resources) {
        _this.textureId = resources[_this.jsonFile].textures
        let idx = 0
        const timerId = setInterval(() => {
          _this.generate(idx)
          app.render(_this.outContainer)
          ++idx
          if (idx === 30) {
            clearInterval(timerId)
          }
        }, 20)
        app.ticker.add((delta) => {
          if (outContainer.position.x < -7000) {
            outContainer.position.x = 0
          }
          if (flag) {
            outContainer.position.x += -1.8 * delta
          }
        })
      }
    },
    addList(para) {
      if (this.list.indexOf(para) === -1) {
        this.list.push(para)
        this.$emit('playMusic', 'm2')
      }
    },
    removeList(para) {
      const idx = this.list.indexOf(para)
      this.list.splice(idx, 1)
      this.$emit('playMusic', 'm2')
      this.outContainer.children.map((it) => {
        if (it.textData === para) {
          // console.log('mached')
          it.children[0].visible = true
          it.children[1].visible = false
        }
      })
    },
    generate(num) {
      const txt = textData[num][0]
      const fullTxt = num + 1 + '.' + txt
      const shortTxt = textData[num][1]
      const ctn = new Container()
      const rand = [0, 7, 2, 4, 8, 5, 1, 7, 2, 5]
      const gotNum = +String(num).slice(-1)

      ctn.textData = txt
      ctn.index = num
      ctn.gameStep = 0
      ctn.position.set(1015 + num * 200, 140 + 40 * rand[gotNum])
      ctn.speed = 1
      ctn.interactive = true
      ctn.on('tap', (evt) => {
        const children = evt.currentTarget.children
        if (children[1].visible) {
          children[2].visible = false
          children[1].visible = false
          children[0].visible = true
          this.removeList(children[0].txtContent)
        } else {
          this.addList(children[0].txtContent)
          children[2].visible = true
          children[1].visible = true
          children[0].visible = false
        }
      })

      let modNum
      let tempNum = num + 1
      if (tempNum === 30) {
        modNum = '00'
      } else if (tempNum > 9) {
        modNum = tempNum
      } else {
        modNum = '0' + tempNum
      }
      let spr = new Sprite(this.textureId[`${modNum}.png`])
      spr.scale.set(0.5)
      spr.anchor.set(0.5)
      spr.visible = false

      const shortStyle = new PIXI.TextStyle({
        fontSize: 10,
        fill: ['#333333'],
      })
      const sTxt = new PIXI.Text(shortTxt, shortStyle)
      sTxt.anchor.set(0.5)
      sTxt.position.set(0, 46)
      sTxt.visible = false

      const style = new PIXI.TextStyle({
        fontSize: 20,
        fill: ['#000000'],
      })
      const nTxt = new PIXI.Text(fullTxt, style)
      nTxt.anchor.set(0.5)
      nTxt.txtNum = modNum
      nTxt.txtContent = txt
      // nTxt.position.set(375 + num * 80, 240 + 20 * rand[gotNum])
      if (num === 0) {
        const style = new PIXI.TextStyle({
          fontFamily: 'Arial',
          fontSize: 22,
          fontStyle: 'italic',
          fontWeight: 'bold',
          fill: ['#ffc33a', '#fc943d'], // gradient
          stroke: '#4a1850',
          strokeThickness: 2,
          dropShadow: true,
          dropShadowColor: '#333333',
          dropShadowBlur: 2,
          dropShadowAngle: Math.PI / 6,
          dropShadowDistance: 2,
        })
        const text = '助力宝鸡创文的30件事，您践行了多少？点击选选看'
        let firstTxt = new PIXI.Text(text, style)
        firstTxt.position.set(375, 340)
        this.outContainer.addChild(firstTxt)
      }

      ctn.addChild(nTxt)
      ctn.addChild(spr)
      ctn.addChild(sTxt)
      this.outContainer.addChild(ctn)
    },
    //
  },
}
</script>

<style lang="less" scoped>
.pg2 {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: white;
}
.p2-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 23.4375rem /* 375/16 */;
  height: 3.6875rem /* 118/16 */;
  box-sizing: border-box;
  padding-left: 11.25rem /* 360/16 */;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('./img/pt-header.jpg');
  background-color: #000;
}
.header-txt-wp {
  position: relative;
  display: flex;
  width: 12.1875rem /* 390/16 */;
  height: 100%;
}
.content-wrapper {
  position: absolute;
  top: 3.6rem;
  right: 0;
  width: 17.9375rem /* 574/16 */;
  background-color: #fff;
  border-left: 1px solid #687b8c;
}
.content-wp {
  max-height: 26.25rem /* 420/16 */;
  overflow-y: scroll;
}
.content-item {
  display: flex;
  position: relative;
  background-color: white;
}
.content-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #687b8c;
  transform: scaleY(0.5);
}
.content-item .content-item-txt {
  display: flex;
  align-items: center;
  height: 2.5rem /* 40/16 */;
  box-sizing: border-box;
  width: 100%;
  padding: 0.375rem /* 6/16 */ 0.5625rem /* 18/16 */;
  font-size: 0.75rem /* 12/16 */;
}
.content-item .content-item-txt .txt-content {
  margin-left: 0.2rem;
  line-height: 1.2;
}
.content-item .content-cross {
  position: relative;
  width: 4rem;
  background-image: url('./img/pt-cross.png');
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: 14px 14px;
}
.content-item .content-cross::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #687b8c;
  transform: scaleX(0.5);
}
.top-notice {
  position: absolute;
  left: 50%;
  top: 5rem;
  margin-left: -5.171875rem /* 331/16 */;
  width: 10.34375rem /* 331/16 */;
  height: 1rem /* 32/16 */;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('./img/pt-top-notice.png');
}
.notice {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 4vh;
  color: #666;
}
.content-fold {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 2.1875rem /* 35/16 */;
  background-color: #687b8c;
  color: white;
}
.content-fold span {
  margin-right: 0.5rem;
}
.header-notice {
  position: relative;
  flex: 1;
}
.spot {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 1.2rem;
}
.spot .spot-inner {
  position: relative;
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background-color: #ff5917;
}
.spot .spot-inner::before {
  content: '';
  position: absolute;
  left: -0.5rem;
  top: -0.5rem;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 1px solid #ff5917;
  animation: ripple 1.2s infinite both;
}
.spot .spot-inner::after {
  content: '';
  position: absolute;
  left: -0.5rem;
  top: -0.5rem;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 1px solid #ff5917;
  animation: ripple 1.2s 0.5s infinite both;
}
.header-notice-txt {
  height: 100%;
  box-sizing: border-box;
  padding: 0.5rem 0 0.5rem 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.header-notice-txt span {
  margin: 0.25rem /* 4/16 */ 0;
  font-size: 0.875rem /* 14/16 */;
  color: #637584;
}
.header-txt {
  display: flex;
  flex-basis: 5rem;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0.625rem /* 10/16 */ 0;
  width: 5rem /* 160/16 */;
  height: 100%;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  background-color: #ff5917;
}
.header-txt .header-num {
  font-size: 1.375rem /* 22/16 */;
  font-weight: bold;
  color: white;
  font-style: italic;
}
.header-txt .header-complete {
  font-size: 0.625rem /* 10/16 */;
  color: white;
}
.start {
  position: relative;
  left: 50%;
  top: 30px;
  margin-left: -34px;
  padding: 8px 14px;
  outline: none;
  border: none;
  background-color: transparent;
  border: 1px solid grey;
  border-radius: 4px;
  color: grey;
}
.start:active {
  opacity: 0.6;
}
.btn-bottom {
  position: absolute;
  left: 50%;
  bottom: 12vh;
  transform: translate(-50%, 100%);
}
.btn1 {
  width: 9.375rem /* 150/16 */;
  height: 2.5625rem /* 41/16 */;
  border-radius: 0.625rem /* 10/16 */;
  border: 1px solid #1a1a1a;
  background-color: #fff;
}
.btn2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 9.375rem /* 150/16 */;
  height: 2.5625rem /* 41/16 */;
  border-radius: 0.625rem /* 10/16 */;
  box-sizing: border-box;
  padding: 0.4375rem /* 14/16 */ 0;
  border: 1px solid #1a1a1a;
  background-color: #1a1a1a;
  background-image: url('./img/pt-complete.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 1.4375rem /* 23/16 */;
  transition: transform 0.3s ease;
}
.btn2__trans {
  transform: translate(-3px, -3px);
}
.transLeftRight {
  animation: transLeftRight 2s linear 2 forwards;
}
@keyframes transLeftRight {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-50%);
  }
  75% {
    transform: translateX(50%);
  }
  98% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateX(0);
  }
}
@keyframes ripple {
  0% {
    opacity: 1;
    transform: scale(0);
  }
  100% {
    opacity: 0;
    transform: scale(2);
  }
}
.shineIt {
  animation: shineIt 12s ease-in-out infinite both;
}
@keyframes shineIt {
  0%,
  20%,
  40% {
    opacity: 0;
  }
  10%,
  12%,
  30%,
  32% {
    opacity: 1;
  }
  41%,
  100% {
    opacity: 0;
  }
}

</style>
